export enum ContainerPaymentType {
    PrePaid = 0,
    FreightCollect = 1
}

export const ContainerPaymentTypeMetadata = {
    '0': {
        display: 'Pre Paid',
        value: 0
    },
    '1': {
        display: 'Freight Collect',
        value: 1
    }
};
